import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  grayColor,
  whiteColor,
} from "../../assets/jss/material-dashboard-pro-react";

const skeletonStyles = () => ({
  plWrapper: {
    position: "relative",
    opacity: 0.4,
    filter: "grayscale(100%)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  plHeader: {
    color: whiteColor,
    borderRadius: "5px 5px 0 0",
    paddingLeft: "5px",
    textAlign: "left",
    fontSize: "12px",
    paddingTop: "2px",
    paddingBottom: "2px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0",
    backgroundColor: grayColor[4], // Light gray instead of client color
  },
  plName: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: "80%",
  },
  plOuterWrapper: {
    width: "100%",
    padding: "4px 0",
    display: "inline-block",
    fontSize: "12px",
    color: grayColor[6],
    whiteSpace: "nowrap",
    overflow: "hidden",
    flex: 1,
  },
  plLineWrapper: {
    width: "100%",
    minHeight: "24px",
    display: "flex",
    lineHeight: "2",
    "& > div:first-child": {
      paddingLeft: "4px",
    },
    "& > div:last-child": {
      paddingRight: "4px",
    },
    cursor: "default", // Remove pointer cursor for skeleton
  },
  plLineDescription: {
    width: "55%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  plValue: {
    width: "22.5%",
    textAlign: "right",
    fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace;',
  },
  plTableHeader: {
    color: whiteColor,
    backgroundColor: grayColor[6],
  },
  plTotal: {
    backgroundColor: grayColor[8],
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  plSubTotal: {
    backgroundColor: grayColor[13],
    "& > div:first-child": {
      paddingLeft: "12px !important",
    },
  },
  plLevel3: {
    color: grayColor[1],
  },
  centerMessage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: "#888",
    fontSize: "14px",
    fontWeight: "500",
    pointerEvents: "none",
    zIndex: 10,
    background: "rgba(255, 255, 255, 0.8)",
    padding: "6px 12px",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
});

const PnlSkeleton = () => {
  const useStyles = makeStyles(skeletonStyles);
  const classes = useStyles();

  // Simplified P&L structure for skeleton - just the structure without content
  const skeletonPlItems = [
    { level: 1, isPercentage: false },
    { level: 2, isPercentage: true },
    { level: 1, isPercentage: false },
    { level: 2, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 1, isPercentage: false },
    { level: 2, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 2, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 1, isPercentage: false },
    { level: 2, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 3, isPercentage: false },
    { level: 1, isPercentage: false },
    { level: 2, isPercentage: false },
    { level: 1, isPercentage: false },
  ];

  return (
    <div className={classes.plWrapper}>
      {/* P&L Header */}
      <div className={classes.plHeader}>
        <div className={classes.plName}></div>
      </div>

      {/* P&L Content */}
      <div className={classes.plOuterWrapper}>
        {/* Table Header */}
        <div className={classes.plLineWrapper}>
          <div
            className={`${classes.plLineDescription} ${classes.plTableHeader}`}
          ></div>
          <div className={`${classes.plValue} ${classes.plTableHeader}`}></div>
          <div className={`${classes.plValue} ${classes.plTableHeader}`}></div>
        </div>

        {/* P&L Items */}
        {skeletonPlItems.map((item, index) => (
          <div
            key={index}
            className={`${classes.plLineWrapper} ${
              item.level === 1
                ? classes.plTotal
                : item.level === 2
                  ? classes.plSubTotal
                  : classes.plLevel3
            }`}
          >
            <div
              className={classes.plLineDescription}
              style={{
                paddingLeft:
                  item.level === 3 ? "14px" : item.level === 2 ? "12px" : "4px",
              }}
            ></div>
            <div className={classes.plValue}></div>
            <div className={classes.plValue}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

PnlSkeleton.propTypes = {};

PnlSkeleton.defaultProps = {};

export default PnlSkeleton;
